import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaBrain, FaUsers,FaArrowRight, FaLeaf, FaQuoteLeft, FaFacebook, FaTwitter, FaLinkedin, FaInstagram ,FaTimes } from "react-icons/fa";

import "./NatureMissionPage.css";

const NatureMissionPage = () => {
  const [currentVideo, setCurrentVideo] = useState(0);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [submissions, setSubmissions] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);
  const [description, setDescription] = useState("");
  const [fetchTrigger, setFetchTrigger] = useState(0);

  const videos = [
    {
      src: "https://res.cloudinary.com/dy8shu8ss/video/upload/v1742307883/5450196-hd_1920_1080_30fps_s5f1pi.mp4",
      caption: "Bird Nesting in Action",
    },
    {
      src: "https://res.cloudinary.com/dy8shu8ss/video/upload/v1742307912/8544157-hd_1080_1920_25fps_kxccps.mp4",
      caption: "Planting Trees Together",
    },
  ];

  // Fetch submissions from backend
  useEffect(() => {
    axios
      .get("http://localhost:5000/api/submissions")
      .then((response) => {
        console.log("Fetched submissions:", response.data);
        setSubmissions(response.data.reverse());
      })
      .catch((error) => console.error("Error fetching submissions:", error));
  }, [fetchTrigger]);

  const handleGenerateVideo = () => {
    alert(
      "Generating a custom video: 'Nature Mission Highlights - Birds Nesting & Tree Planting'. Imagine a 1-minute montage of volunteers building nests and planting trees!"
    );
  };

  const handleVideoEnd = () => {
    setCurrentVideo((prev) => (prev + 1) % videos.length);
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (imagePreview || description) {
      const isDuplicate = submissions.some((submission) => submission.text === description);
      if (isDuplicate) {
        alert("This description has already been submitted!");
        return;
      }
      try {
        console.log("Submitting:", { image: imagePreview, text: description });
        const response = await axios.post("http://localhost:5000/api/submissions", {
          image: imagePreview,
          text: description,
        });
        console.log("Submission response:", response.data);
        setFetchTrigger((prev) => prev + 1);
        setImagePreview(null);
        setDescription("");
        setIsFormOpen(false);
      } catch (error) {
        console.error("Error submitting:", error);
        alert("Failed to submit. Please try again.");
      }
    } else {
      alert("Please upload an image or add a description before submitting.");
    }
  };

  // Deduplicate submissions before rendering
  const uniqueSubmissions = Array.from(
    new Map(submissions.map((submission) => [submission.text, submission])).values()
  );

  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: false,
  };

  return (
    <div className="nature-mission-page">
      <section className="hero" id="home">
        <div className="parallax-bg"></div>
        <div className="video-container">
          <video
            key={currentVideo}
            autoPlay
            muted
            playsInline
            className="hero-video"
            onEnded={handleVideoEnd}
          >
            <source src={videos[currentVideo].src} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className="video-caption">{videos[currentVideo].caption}</div>
          <div className="video-dots">
            {videos.map((_, index) => (
              <span
                key={index}
                className={`dot ${index === currentVideo ? "active" : ""}`}
                onClick={() => setCurrentVideo(index)}
              ></span>
            ))}
          </div>
        </div>
        <div className="hero-content">
          <h1>Small Actions, Big Impact</h1>
          
         
        </div>
      </section>

      <nav className="sticky-nav">
        <a href="#home">Home</a>
        <a href="#initiatives">Initiatives</a>
        <a href="#progress">Progress</a>
        <a href="#articles">Learn</a>
        <a href="#get-involved">Get Involved</a>
      </nav>

      <section className="initiatives" id="initiatives">
        <h2>Our Initiatives</h2>
        <div className="initiative-grid">
          <div className="initiative-card">
            <img src="https://res.cloudinary.com/dy8shu8ss/image/upload/v1742383131/pexels-taryn-elliott-5235043_vfmb5q.jpg" alt="Bird Nest" />
            <h3>Bird Help</h3>
            <p>Build bird nests with recycled materials—20 made so far!</p>
          </div>
          <div className="initiative-card">
            <img src="https://res.cloudinary.com/dy8shu8ss/image/upload/v1742383131/pexels-lara-jameson-9324330_inkgqh.jpg" alt="Tree Planting" />
            <h3>Tree Planting</h3>
            <p>50 trees planted—help us grow the forest!</p>
          </div>
          <div className="initiative-card">
            <img src="https://res.cloudinary.com/dy8shu8ss/image/upload/w_1000,ar_1:1,c_fill,g_auto,e_art:hokusai/v1742383131/DALL_E_2025-03-19_16.47.26_-_A_visually_appealing_eco-friendly_infographic_titled_Eco-Friendly_Habits__5_Easy_Ways_to_Live_Greener_Every_Day_._The_image_includes_five_illustrated_cagpxl.webp" alt="Eco Habits" />
            <h3>Eco-Friendly Habits</h3>
            <p>5 easy ways to live greener every day.</p>
          </div>
        </div>
      </section>

      <section className="progress" id="progress">
        <h2>Our Impact</h2>
        <div className="progress-grid">
          <div className="progress-card">
            <h3>50</h3>
            <p>Trees Planted</p>
          </div>
          <div className="progress-card">
            <h3>20</h3>
            <p>Bird Nests Built</p>
          </div>
        </div>
      </section>

      <section className="testimonials">
        <h2>What People Say</h2>
        <div className="testimonial-grid">
          <div className="testimonial-card">
            <p>"Building nests was so rewarding—I’ve made 3 already!"</p>
          </div>
          <div className="testimonial-card">
            <p>"Planting trees with my kids was a blast!"</p>
          </div>
          <div className="testimonial-card">
            <p>"The clean-up made our park shine again."</p>
          </div>
        </div>
      </section>

      <section className="articles" id="articles">
        <h2>Learn & Contribute</h2>
        <div className="article-grid">
          <div className="article-card">
            <h3>How to Make a Nest for Birds</h3>
            <p>Building a bird nest is simple and rewarding! Follow these steps:</p>
            <ol>
              <li>Gather materials: Use twigs, grass, and recycled string.</li>
              <li>Shape the base: Form a small bowl with twigs.</li>
              <li>Add padding: Line it with soft grass or moss.</li>
              <li>Place it safely: Secure it in a tree away from predators.</li>
            </ol>
            <p>Try it out and share your creations with us!</p>
            <button onClick={() => setIsFormOpen(true)}>
              Share Your Contribution <span className="info-icon">ℹ</span>
            </button>

            {isFormOpen && (
              <div className="try-it-form">
                <h4>Share Your Nest</h4>
                <form onSubmit={handleSubmit}>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageUpload}
                  />
                  {imagePreview && (
                    <img src={imagePreview} alt="Preview" className="image-preview" />
                  )}
                  <textarea
                    placeholder="Describe your nest"
                    value={description}
                    onChange={(e) => {
                      console.log("Textarea value:", e.target.value);
                      setDescription(e.target.value);
                    }}
                    rows="3"
                  />
                  <button type="submit">Submit</button>
                  <button type="button" onClick={() => setIsFormOpen(false)}>
                    Cancel
                  </button>
                </form>
              </div>
            )}

            {uniqueSubmissions.length > 0 && (
              <div className="submissions">
                <h4>Your Creations</h4>
                <Slider {...carouselSettings}>
                  {uniqueSubmissions.map((submission) => {
                    console.log("Rendering submission:", submission);
                    return (
                      <div key={submission._id} className="submission-item">
                        <div className="image-container">
                          {submission.image ? (
                            <img src={submission.image} alt="User nest" className="submission-image" />
                          ) : (
                            <p>No image available</p>
                          )}
                        </div>
                        <div className="description-container">
                          {submission.text ? (
                            <p>{submission.text}</p>
                          ) : (
                            <p>No description available</p>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </Slider>
              </div>
            )}
          </div>
        </div>
      </section>

      <section className="get-involved" id="get-involved">
        <h2>Get Involved</h2>
        <div className="get-involved-grid">
          <div className="card">
            <h3>Take the Pledge</h3>
            <form>
              <input type="text" placeholder="Your Name" required />
              <input type="email" placeholder="Your Email" required />
              <textarea placeholder="Your Pledge" rows="3" required></textarea>
              <button type="submit">Submit Pledge</button>
            </form>
          </div>
          <div className="card">
            <h3>Join a Drive</h3>
            <p>Next clean-up: April 10, 2026. Sign up now!</p>
            <button>Sign Up</button>
          </div>
          <div className="card">
            <h3>Donate</h3>
            <p>Your support keeps us growing.</p>
            <button>Donate Now</button>
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <h3>About Us</h3>
            <p>Vero Disruptors is a leading innovator in data-driven solutions, providing cutting-edge services to help businesses grow and succeed.</p>
          </div>
          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/products">Products</a></li>
              <li><a href="/services">Services</a></li>
              <li><a href="/careers">Careers</a></li>
              <li><a href="/contactus">Contact Us</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Follow Us</h3>
            <div className="social-links">
              <a href="https://www.facebook.com/share/1AF81Af26p/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FaFacebook />
              </a>
              
              <a href="https://www.linkedin.com/company/vero-disruptors-pvt-ltd/?originalSubdomain=in" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FaLinkedin />
              </a>
              
            </div>
            
          </div>
          
        </div>
        <div className="footer-legal-links">
        
        <a href="/contactus">Contact Us</a>
        <a href="/terms">Term Of Use</a>
        <a href="/privacy">Privacy Statement</a>
        <a href="/refund">            Refund Policy
      </a>
        <a href="/about">About Us</a>
      
      </div>
      
        <div className="contactus-footer">
          <p>Copyright © Vero Disruptors {new Date().getFullYear()}. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default NatureMissionPage;